$(function() {
    'use strict';
    
    $('#form-password-reset').validate({
        messages: {
            'username': {
                required: "Privalote įvesti savo naudotojo vardą arba el. pašto adresą"
            }
        }
    });
});
